import styled from "styled-components"

import media, {minWidthMedia} from "@irati/ui/src/global/media"
import padding from "@irati/ui/src/global/padding"
import Tabs from "@irati/ui/src/Tabs"
import {H3} from "@irati/ui/src/Typography"

import StatementItems from "../../StatementItems/StatementItems"
import ScheduledTransfers from "../../ScheduledTransfers"

export const ButtonWrapper = styled.div`
  text-align: right;
`

export const StyledStatementItems = styled(StatementItems)`
  margin-top: ${padding.small};

  ${minWidthMedia.tablet`
    margin-top: ${padding.base};
  `}

  ${media.tablet`
    padding: 0 15px;
  `}
`

export const StyledScheduledTransfers = styled(ScheduledTransfers)`
  margin-top: ${padding.small};

  ${minWidthMedia.tablet`
    margin-top: ${padding.base};
  `}

  ${media.tablet`
    padding: 0 15px;
  `}
`

export const StyledTabs = styled(Tabs)`
  ${media.tablet`
    margin: 0 -15px;
  `}
`

export const DesktopHeader = styled(H3)`
  display: none;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    display: inline;
  `}
`
